<template>
    <div class="dialog-container flex flex-direction padding-tb-sm" :style="`display: ${dialogVisible ? 'flex' : 'none'}`">
        <div class="progress-viewer-header flex align-center justify-between padding-lr-xs">
            <div class="flex align-center">
                <div class="progress-viewer-header__icon text-xl">
                    <i class="el-icon-success text-green" v-if="status === 1"></i>
                    <i class="el-icon-loading text-blue" v-else></i>
                </div>
                <div class="progress-viewer-header__status flex align-center">
                   <div class="margin-left-xs text-bold text-sm">{{status === 1 ? '打包完成' : status === 0 ? '正在打包' : '正在获取打包状态'}}</div>
                    <a class="text-blue margin-left-sm text-sm" :href="down_url" target="_blank" v-if="status === 1">下载</a>
                </div>
            </div>
            <i class="el-icon-close text-df cursor" @click="cancel"></i>
        </div>
    </div>
</template>

<script>
import {downloadFiles,getZipState} from "@/api";
import {TOAST, toast} from "@/utils/utils";

export default {
    name: "ExportLoading",
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        type: { // 1 相关材料 打包 0 首页下载打包
            type: Number,
            default: 0
        },
        p_id: {
            type: [String,Number],
            default: ''
        },
        pid: {
            type: [String,Number],
            default: ''
        },

    },
    data() {
        return {
            timeId: null, // 一次性计时器id
            status:-1,// -1 未知 0 进行中 1 完成
            down_url:''
        }
    },
    created() {

    },
    methods: {
        async exportNormZipFiles(){
            let _data = await downloadFiles(this.p_id,this.pid,this.type)
            if (_data.status === 200){
                this.status =  0
                if (!this.timeId) this.setTimeInterval()
            }else {
                this.cancel()
                toast(_data.msg,TOAST.error)
            }
        },
        async getNormZipState(){
            let _data =  await getZipState()
            if (_data.status === 200){
                this.status = 1
                this.down_url = _data.data.url
                clearInterval(this.timeId)
            }else if (_data.status === 300){
                this.exportNormZipFiles()
            }else {
                if (!this.timeId) this.setTimeInterval()
            }
        },
        setTimeInterval() {
            let _this = this
            _this.timeId = setInterval(() => {
                _this.getNormZipState()
            }, 1000)
        },
        cancel() {
            this.$emit('watchState', false)
        }
    },
    watch: {
        dialogVisible() {
            if (this.dialogVisible) {
                this.getNormZipState()
            } else {
                clearInterval(this.timeId)
                this.status = -1
                this.timeId = null
            }
        }
    },
    filters: {}
}
</script>

<style scoped lang="scss">
.dialog-container {
    width: 420px;
    background-color: #ffffff;
    border-radius: 8px;
    border: 1px solid var(--grayLine);
    position: fixed;
    z-index: 100;
    bottom: 30px;
    right: 30px;
}
</style>